export default "/signup/_next/static/chunks/fonts/lineto-circular-medium-f9120fb7b950ff0e432e374bc4485742.woff";